import { addDisplayName, addEffect, flowMax } from 'ad-hok'
import { FC } from 'react'

interface Props {
  path: string
}

const StaticRedirect: FC<Props> = flowMax(
  addDisplayName('StaticRedirect'),
  addEffect(({ path }) => () => {
    window.location.href = path
  }),
  () => <></>
)

export default StaticRedirect
